import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/layoutComponents/Header';
import Footer from './components/layoutComponents/Footer';
import Reservations from './components/reservations/Reservations';
import Inventory from './components/inventory/Inventory';
import Students from './components/students/Students';
import Users from './components/users/Users';
import Login from './components/login/Login';
import { NotificationProvider } from './contexts/NotificationContext';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [userId, setUserId] = useState(null);

  return (
    <NotificationProvider>
      <Router>
      {isAuthenticated && (
        <Header
          userRole={userRole}
          userId={userId}
          setIsAuthenticated={setIsAuthenticated}
        />
      )}

      <Routes>
        {/* Public Route */}
        <Route path="/login" element={
          <Login
            setIsAuthenticated={setIsAuthenticated}
            setUserRole={setUserRole}
            setUserId={setUserId}
          />
        } />

        {/* Private Routes */}
        <Route path="/reservations" element={
          isAuthenticated ? <Reservations userRole={userRole} userId={userId} /> : <Navigate to="/login" />
        } />
        <Route path="/inventory" element={
          isAuthenticated ? <Inventory userRole={userRole} /> : <Navigate to="/login" />
        } />
        <Route path="/students" element={
          isAuthenticated && (userRole === 'ROLE_ADMIN' || userRole === 'ROLE_STAFF') ?
            <Students /> : <Navigate to="/login" />
        } />
        <Route path="/users" element={
          isAuthenticated && (userRole === 'ROLE_ADMIN' || userRole === 'ROLE_STAFF') ?
            <Users userRole={userRole} /> : <Navigate to="/login" />
        } />

        {/* Default route */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>

      <Footer />
      </Router>
    </NotificationProvider>
  );
}

export default App;
